import { Avatar as FplAvatar } from '@figma/fpl-components';
import { Avatar } from '@/UI/Avatar/Avatar';
import { UserCircleIcon } from '@/UI/Icons/UserCircleIcon';
import { useFplMigrationFlag } from '@/contexts/FplMigrationContext';

const DRAWER_USER_AVATAR_SX = { width: '24px', height: '24px' } as const;

export function DrawerUserAvatar({ displayName, photoURL }: { displayName: string; photoURL?: string | null }) {
  const isFplMigrationEnabled = useFplMigrationFlag();

  if (isFplMigrationEnabled) {
    return <FplAvatar aria-label={displayName} name={displayName} src={photoURL || undefined} size="md" />;
  }

  return photoURL ? (
    <Avatar aria-label={displayName} alt={displayName} src={photoURL} sx={DRAWER_USER_AVATAR_SX} />
  ) : (
    <UserCircleIcon className="drawer-user-avatar-fallback" width={24} height={24} />
  );
}
